import { CountyResource } from './CountyResource';

export class CountyListResource {
    countyList: CountyResource[];
}